import { observer } from 'mobx-react'
import rootStore from '../../../store/RootStore'
import { Text } from '@chakra-ui/react'
import React from 'react'

const NavbarSectionTitle = observer(props => {
  const {
    reportStore: { sectionTitle },
  } = rootStore
  return (
    <Text
      textStyle="h2"
      fontWeight="900"
      lineHeight="20px"
      {...props}
    >
      {sectionTitle}:
    </Text>
  )
})

export { NavbarSectionTitle }
